import { useStrings } from '../tenant/TenantProvider';
import { cx } from './cx';

export function Badge({ tone, dot, children, className }) {
  return (
    <span className={cx('badge', tone && `badge--${tone}`, className)}>
      {dot && <span className="badge__dot" aria-hidden="true" />}
      {children}
    </span>
  );
}

const DIFFICULTY_CLASS = { Easy: 'easy', Medium: 'medium', Hard: 'hard' };

export function DifficultyLabel({ level, className }) {
  const t = useStrings();
  const key = DIFFICULTY_CLASS[level];
  return (
    <span className={cx('difficulty', key && `difficulty--${key}`, className)}>
      {t(`difficulty.${level}`, { fallback: level })}
    </span>
  );
}

const VERDICT_TONE = {
  Accepted: 'accepted',
  'Wrong Answer': 'rejected',
  'Runtime Error': 'rejected',
  'System Error': 'rejected',
  TLE: 'limit',
  'Time Limit Exceeded': 'limit',
  MLE: 'limit',
  'Memory Limit Exceeded': 'limit',
  'Compilation Error': 'limit',
  PENDING: 'pending',
};

export function verdictTone(verdict) {
  return VERDICT_TONE[verdict] ?? 'rejected';
}

export function VerdictLabel({ verdict, pending, className }) {
  const t = useStrings();
  const key = pending ? 'PENDING' : verdict;
  return (
    <span className={cx('verdict', `verdict--${verdictTone(key)}`, className)}>{t(`verdicts.${key}`, { fallback: verdict })}</span>
  );
}

export function Avatar({ name, size, className }) {
  const initial = (name || '?').trim().charAt(0) || '?';
  return (
    <span className={cx('avatar', size === 'lg' && 'avatar--lg', className)} aria-hidden="true">
      {initial}
    </span>
  );
}

export function Kbd({ children }) {
  return <kbd className="kbd">{children}</kbd>;
}

export function Meter({ value, max, tone, label }) {
  const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div
      className={cx('meter', tone && `meter--${tone}`)}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={value}
    >
      <div className="meter__fill" style={{ width: `${percent}%` }} />
    </div>
  );
}
